import { render, staticRenderFns } from "./KullaniciIslemleri.vue?vue&type=template&id=39b2b3fb"
import script from "./KullaniciIslemleri.vue?vue&type=script&lang=js"
export * from "./KullaniciIslemleri.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports